import styled from 'styled-components'
import { IMain } from './Main'
import { colors } from '../../styles'

export const GreyContainerTemplate = styled.div`
  background-color: ${colors.grey};
  display: flex;
  min-height: calc(100vh - 48px);
  height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
`

export const SilverContainerTemplate = styled.div`
  background-color: ${colors.silver};
  border-radius: 4px 4px 0 0;

  display: flex;
  justify-content: space-around;
  align-items: flex-start;

  flex: 1;
`

export const ContentTemplate = styled.div<IMain>`
  background-color: ${colors.white};
  border-radius: 4px 4px 0 0;
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12),
    0 2px 4px -1px rgba(0, 0, 0, 0.2);
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: ${({ scrollContent }) => (scrollContent ? 'initial' : '100%')};
  flex: 1;

  .title-block {
    word-break: break-word;
  }
`

export const SidebarSecondaryTemplate = styled.div`
  padding: 16px 0;
  background-color: ${colors.silver};
  border-radius: 4px 0 0 0;
  width: 247px;
  flex: 0 0 247px;
  height: 100%;
`

export const SidebarPrimaryTemplate = styled.div`
  color: ${colors.white};
  background-color: ${colors.grey};
  width: 247px;
  flex: 0 0 247px;
  height: 100%;
`

export const ChildrenContainer = styled.div`
  height: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const DragOverlay = styled.div<{ show?: boolean }>`
  position: absolute;
  z-index: ${({ show }) => (show ? 100 : -1)};
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  top: 0;
`
